import React from 'react';

const CircularProgress = ({ size = 20, color = 'border-blue-500' }) => {
  return (
    <div
      className={`border-4 border-t-transparent border-solid rounded-full animate-spin ${color}`}
      style={{ width: size, height: size }}
    />
  );
};

export default CircularProgress;
